/**
 * @generated SignedSource<<1acf298fc246a99f1c1c05d48f613398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailItemInvoice_user$data = {
  readonly profile: {
    readonly email: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedDetailItemInvoice_user";
};
export type PdpSharedDetailItemInvoice_user$key = {
  readonly " $data"?: PdpSharedDetailItemInvoice_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailItemInvoice_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "93dd0139e24f5d53c02ad4ca197e0255";

export default node;
